import { getCurrentUserId, getCurrentTeamUrl } from '../services/store-service';

const STORAGE_KEY = 'nifty_user_storage';

const hasLocalStorage = () => {
    try {
        return 'localStorage' in window && typeof localStorage === 'object' && typeof localStorage.getItem === 'function' && typeof localStorage.setItem === 'function';
    } catch (e) {
        return false;
    }
}

const getStorageKey = () => {
    if (!getCurrentUserId() || !getCurrentTeamUrl()) {
        return null;
    }

    return `${getCurrentTeamUrl()}_${getCurrentUserId()}`;
}

export const set = (key, value) => {
    if (!hasLocalStorage() || !getStorageKey()) {
        return null;
    }

    const storageData = getData() || {};

    if (!(getStorageKey() in storageData)) {
        storageData[getStorageKey()] = {};
    }

    storageData[getStorageKey()][key] = value;

    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(storageData));
    } catch(e) {}
}

export const get = key => {
    if (!hasLocalStorage() || !getStorageKey()) {
        return null;
    }

    const storageData = getData();

    if (!storageData || !(getStorageKey() in storageData)) {
        return null;
    }

    return storageData[getStorageKey()][key];
}

const getData = () => {
    let result;

    try {
        result = localStorage.getItem(STORAGE_KEY);
    } catch(e) {
        result = null;
    }

    try {
        return JSON.parse(result);
    } catch(e) {
        return result || {};
    }
}
